import React from 'react';

import CityFilter from './__partials/CityFilter';
import RegionFilter from './__partials/RegionFilter';
import { CityList, RegionList } from './types';

interface LocationProps {
    cityList: CityList;
    regionList?: RegionList;
}

const Location = ({ cityList, regionList }: LocationProps) => (
    <>
        {regionList && <RegionFilter regionList={regionList} />}
        <CityFilter cityList={cityList} regionList={regionList} />
    </>
);

export default Location;
